import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles, useTheme, NoSsr, Grid, Button, useMediaQuery, Typography} from '@material-ui/core';
import {SectionHeader} from 'components/molecules';
import SwiperReviews from "../../../../components/molecules/SwiperReviews";
import {showDemo} from "common"

const reviews = [
    {
        authorName: 'Temi V',
        authorTitle: 'Controller, GEM',
        text: 'It was great. The team knows ASC606 and provided expertise while we implemented the tool. The reports are what we now reconcile to and is now our "source of truth".',
        authorPhoto: 'https://logo.clearbit.com/gem.com'
    },
    {
        authorName: 'Tom H',
        authorTitle: 'Chief Financial Officer, BlineMedical',
        text: 'RevLock allowed us to implement proper ASC 606 revenue recognition on a standardized commercial product at a reasonable cost without having to change our general ledger system.',
        authorPhoto: 'https://logo.clearbit.com/blinemedical.com/'
        
    },
    {
        authorName: 'Nick M',
        authorTitle: 'Chief Financial Officer, Thycotic',
        text: 'Excellent team and great product. We were able to get up and running quickly without any changes to our existing processes. We leverage the flexible reporting abilities.',
        authorPhoto: 'https://logo.clearbit.com/thycotic.com'
    }
];

const useStyles = makeStyles(theme => ({
    quickStartSection: {
        '& .section-header__cta-container': {
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column',
                '& .section-header__cta-item-wrapper': {
                    width: '100%',
                    '&:last-child': {
                        marginLeft: 0,
                        marginTop: theme.spacing(1),
                    },
                    '& .MuiButtonBase-root': {
                        width: '100%',
                    },
                },
            },
        }
    },
    fontWeightBold: {
        fontWeight: '900',
    },
    editor: {
        paddingLeft: `${theme.spacing(2)}px !important`,
        paddingRight: `${theme.spacing(2)}px !important`,
        borderRadius: theme.spacing(1 / 2),
        width: '100%',
    },
    logoImg: {
        maxWidth: 100,
    },
}));

const Difference = ({className, onContact, ...rest}) => {
    const classes = useStyles();
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    
    const docsButton = (
       <Button size="large" variant="outlined" color="primary" component="a" onClick={showDemo}>
           See interactive demo
       </Button>
    );
    
    const buyButton = (
       <Button
          size="large"
          variant="contained"
          color="primary"
          component="a"
          onClick={onContact}>
           Contact Us
       </Button>
    );
    
    return (
       <div className={className} {...rest}>
           <Grid container justify="space-between" spacing={4}>
               <Grid item xs={12}>
                   <Grid container justify="space-between" spacing={isMd ? 4 : 2}>
                       <Grid item xs={12} md={6} data-aos={'fade-right'}>
                           <SectionHeader
                              title="What makes REVLOCK Different"
                              subtitle="A Specialized Solution that Fits your Exact Needs"
                              ctaGroup={[docsButton, buyButton]}
                              align={isMd ? 'left' : 'center'}
                              disableGutter
                              titleVariant="h3"
                              titleProps={{className: classes.fontWeightBold}}
                              className={classes.quickStartSection}
                           />
                           <Grid style={{paddingTop: 16}}
                                 container justify="space-between" spacing={isMd ? 4 : 2}
                                 direction={isMd ? 'row' : 'column-reverse'}>
                               <Grid item xs={12} container alignItems="center" data-aos={'fade-right'}>
                                   <Grid container justify="flex-start" alignItems="center" spacing={2}>
                                       <Grid item xs={12} md={6}>
                                           <Typography color="primary" variant="h4"
                                                       gutterBottom>Specialized</Typography>
                                           <Typography color="textPrimary" variant="body1">
                                               Revenue Recognition is what we do! Accounting focused.
                                           </Typography>
                                       </Grid>
                                       <Grid item xs={12} md={6}>
                                           <Typography color="primary" variant="h4" gutterBottom>Controlled</Typography>
                                           <Typography color="textPrimary" variant="body1">
                                               Controlled, Transparent, and Auditable.
                                           </Typography>
                                       </Grid>
                                       <Grid item xs={12} md={6}>
                                           <Typography color="primary" variant="h4"
                                                       gutterBottom>Integration</Typography>
                                           <Typography color="textPrimary" variant="body1">
                                               Easily Integrates with CRM, Billing / Invoicing, and GL Packages.
                                           </Typography>
                                       </Grid>
                                       <Grid item xs={12} md={6}>
                                           <Typography color="primary" variant="h4" gutterBottom>Support</Typography>
                                           <Typography color="textPrimary" variant="body1">
                                               We know what your accounting and finance team needs.
                                           </Typography>
                                       </Grid>
                                       <Grid item xs={12} md={6}>
                                           <Typography color="primary" variant="h4" gutterBottom>Overall
                                               Value</Typography>
                                           <Typography color="textPrimary" variant="body1">
                                               Most functionality, best fit, fastest to market = highest overall value.
                                           </Typography>
                                       </Grid>
                                   </Grid>
                               </Grid>
                           </Grid>
                       </Grid>
                       <Grid item container alignItems="center" xs={12} md={6} data-aos={'fade-left'}>
                           <NoSsr>
                               <SwiperReviews
                                  items={reviews}
                               />
                           </NoSsr>
                       </Grid>
                   </Grid>
               </Grid>
           </Grid>
       </div>
    );
};

Difference.propTypes = {
    /**
     * External classes
     */
    className: PropTypes.string,
};

export default Difference;
